import { SAMPLES } from '@/core/samples.ts';
import { NOTES } from '@/core/contants.ts';

export interface Sample {
  sample: SampleName;
  offset?: number;
  gain?: number;
}

export interface Note {
  name: string;
  major: Sample;
  minor: Sample;
  dominant: Sample;
}

export type NOTE = keyof typeof NOTES;

export type Sequence = Sample[][][];

export enum SIGNATURE {
  '3/4' = '3/4',
  '4/4' = '4/4',
  '5/4' = '5/4',
  '6/8' = '6/8',
  '7/8' = '7/8',
  '12/8' = '12/8',
}

export type SampleName = keyof typeof SAMPLES;

type ChordQuality = 'major' | 'minor' | 'dominant'; // | 'augmented' | 'diminished' | 'major 7th' | 'minor 7th'
  // | 'diminished 7th' | 'suspended' | 'suspended 2nd' | 'suspended 4th';

export interface ProgressionOption {
  numeral: string;
  chordQuality: ChordQuality;
  interval: number;
}

export type SelectedChord = [number, number];

export interface ChordPickerBar {
  name: string;
  options: ProgressionOption[];
  isEnabled: (optionIndex: number) => boolean;
}

declare global {
  interface Window {
    ka: {
      url: string;
      domain: string;
      track?: (p: string, r?: string) => void;
    }
  }
}
